
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"path-1","d":"M0 0h1023.94v1017.74H0z"}})]),_c('g',{attrs:{"id":"f_logo_RGB-Blue_1024(1)","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Group-3","transform":"translate(.06 .04)"}},[_c('mask',{attrs:{"id":"mask-2","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_c('path',{attrs:{"d":"M1023.94 511.96c0-282.77-229.23-512-512-512s-512 229.23-512 512c0 255.554 187.231 467.37 432 505.78V659.96h-130v-148h130v-112.8c0-128.32 76.438-199.2 193.39-199.2 56.017 0 114.61 10 114.61 10v126h-64.562c-63.603 0-83.438 39.467-83.438 79.957v96.043h142l-22.7 148h-119.3v357.78c244.769-38.41 432-250.226 432-505.78","id":"Fill-1","fill":"#1877F2","mask":"url(#mask-2)"}})]),_c('path',{attrs:{"d":"M711.3 660L734 512H592v-96.043c0-40.49 19.835-79.957 83.438-79.957H740V210s-58.593-10-114.61-10C508.438 200 432 270.88 432 399.2V512H302v148h130v357.78a515.834 515.834 0 0080 6.22c27.216 0 53.933-2.13 80-6.22V660h119.3","id":"Fill-4","fill":"#FFF"}})])])
          )
        }
      }
    